module.exports = __webpack_public_path__ + "static/clubSynergie-cebcd9223589005a7e662fda5efe4741.jpg";